import { Box, Typography } from "@mui/material";

const sx = {
  root: {
    display: "flex",
    gap: "1px"
  }
};

export default function LabelGrid({ rows }) {
  return (
    <Box sx={sx.root}>
      {rows.map((item, i) => {
        const isLastItem = rows.length === i + 1;
        const isFirstItem = i === 0;
        return (
          <LabelGridItem label={item.label} value={item.value} isFirstItem={isFirstItem} isLastItem={isLastItem} />
        );
      })}
    </Box>
  );
}

const sxItem = {
  label: {
    px: 5,
    py: 4,
    backgroundColor: "blue.c20",
    color: "blue.c100"
  },
  value: {
    p: 5,
    backgroundColor: "common.white",
    color: "darkBlue.c70"
  }
};

function LabelGridItem({ label, value, isFirstItem, isLastItem }) {
  const radiusLabel = {
    borderTopLeftRadius: isFirstItem ? "5px" : null,
    borderTopRightRadius: isLastItem ? "5px" : null
  };
  const radiusValue = {
    borderBottomLeftRadius: isFirstItem ? "5px" : null,
    borderBottomRightRadius: isLastItem ? "5px" : null
  };
  return (
    <Box flexGrow={isLastItem ? "1" : "initial"}>
      <Box sx={[sxItem.label, radiusLabel]}>
        <Typography variant="caption2">{label}</Typography>
      </Box>
      <Box sx={[sxItem.value, radiusValue]}>
        <Typography variant="caption1">{value}</Typography>
      </Box>
    </Box>
  );
}
